import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { JobFilters } from "../../domain";
import { JobsRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class GetJobFiltersUsecase implements UseCase<string, JobFilters> {

  constructor(private jobRepository: JobsRepository) {
  }

  execute(params: string): Observable<JobFilters> {
    return this.jobRepository.getJobFilters(params);
  }

}
